import { styled } from "@mui/material/styles"

import Column from "../../../common/components/Column"

/** White bordered card used to group a settings section, matching the Profile tab card. */
export default styled(Column)(({ theme }) => ({
  backgroundColor: "#fff",
  border: "1px solid",
  borderColor: theme.palette.colors.gray200,
  borderRadius: "16px",
  padding: theme.spacing(3),
  gap: theme.spacing(2),
  [theme.breakpoints.only("xs")]: {
    padding: theme.spacing(2),
  },
}))
